import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { CommonTypes } from "./types";
import { handle } from "@dp/common";
import { UIError } from "./errors";

var Common = /*#__PURE__*/function () {
  function Common(config, axios, cart) {
    var _this = this;

    _classCallCheck(this, Common);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    _defineProperty(this, "cart", void 0);

    _defineProperty(this, "checkAndGetErrorDescription", function (error) {
      var _this$cart$parseError;

      var faultOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var errObj = error;
      var faults = (_this$cart$parseError = _this.cart.parseErrors(errObj)) === null || _this$cart$parseError === void 0 ? void 0 : _this$cart$parseError.faults;
      var errorDescription = null;

      if (faults && faults[0]) {
        if (faultOverride && faults[0].faultCode === faultOverride.faultCode) {
          errorDescription = faultOverride.faultCodeDescriptionOverride;
        } else {
          errorDescription = faults[0].faultDescription;
        }
      }

      return errorDescription ? new Error(errorDescription) : null;
    });

    this.axios = axios;
    this.config = config;
    this.cart = cart;
  }

  _createClass(Common, [{
    key: "getAppAttributes",
    value: function () {
      var _getAppAttributes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axios.get(this.config.postfix.APP_INIT).then(function (resp) {
                  return _this2._processAppAttributes(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAppAttributes() {
        return _getAppAttributes.apply(this, arguments);
      }

      return getAppAttributes;
    }()
  }, {
    key: "_processAppAttributes",
    value: function _processAppAttributes(response) {
      var _response$data, _response$data$appCon, _response$data2;

      var indicatorsMap = this.createIndicatorsMap((_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$appCon = _response$data.appConfigData) === null || _response$data$appCon === void 0 ? void 0 : _response$data$appCon.indicatorsMasterList);
      response.data.appConfigData["indicatorsMap"] = indicatorsMap;
      return response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.appConfigData;
    }
  }, {
    key: "createIndicatorsMap",
    value: function createIndicatorsMap(indicatorsList) {
      var indicatorsMap = {};
      indicatorsList === null || indicatorsList === void 0 ? void 0 : indicatorsList.forEach(function (indicator) {
        indicatorsMap[indicator.indicatorCode] = indicator;
      });
      return indicatorsMap;
    }
  }, {
    key: "getCityStateFromZip",
    value: function () {
      var _getCityStateFromZip = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload, jwtToken) {
        var headers, _yield$handle, _yield$handle2, err, response;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                _context2.next = 4;
                return handle(this.axios.post(this.config.postfix.GET_CITY_STATE_BY_ZIPCODE, payload, {
                  headers: headers
                }));

              case 4:
                _yield$handle = _context2.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                err = _yield$handle2[0];
                response = _yield$handle2[1];

                if (!err) {
                  _context2.next = 12;
                  break;
                }

                throw err;

              case 12:
                return _context2.abrupt("return", response.data);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getCityStateFromZip(_x, _x2) {
        return _getCityStateFromZip.apply(this, arguments);
      }

      return getCityStateFromZip;
    }()
  }, {
    key: "getCheckoutInitAttributes",
    value: function () {
      var _getCheckoutInitAttributes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref) {
        var jwtToken, commonQueryParams, locale, headers;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                jwtToken = _ref.jwtToken;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = {};

                if (jwtToken) {
                  headers = {
                    Authorization: "Bearer ".concat(jwtToken)
                  };
                }

                _context3.next = 7;
                return this.axios.get(this.config.postfix.CHECKOUT_INIT, {
                  params: {
                    locale: locale
                  },
                  headers: headers
                }).then(function (resp) {
                  return resp.data.response;
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 7:
                return _context3.abrupt("return", _context3.sent);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getCheckoutInitAttributes(_x3) {
        return _getCheckoutInitAttributes.apply(this, arguments);
      }

      return getCheckoutInitAttributes;
    }()
  }, {
    key: "getGiftCardSessionAttributes",
    value: function () {
      var _getGiftCardSessionAttributes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.axios.get(this.config.postfix.GC_SESSION_INIT);

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", response.data);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getGiftCardSessionAttributes() {
        return _getGiftCardSessionAttributes.apply(this, arguments);
      }

      return getGiftCardSessionAttributes;
    }()
  }, {
    key: "getResourceBundles",
    value: function () {
      var _getResourceBundles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.axios.get(this.config.postfix.RESOURCE_BUNDLE);

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", response.data);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getResourceBundles() {
        return _getResourceBundles.apply(this, arguments);
      }

      return getResourceBundles;
    }()
  }, {
    key: "handleUIErrorAndOverride",
    value: function handleUIErrorAndOverride(actualError, overrideData) {
      var hardOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (hardOverride) {
        return overrideData;
      }

      if (actualError instanceof UIError) {
        var _actualError$errors$, _actualError$errors, _actualError$errors$2, _actualError$errors$3, _actualError$errors2, _actualError$errors2$, _actualError$errors$4, _actualError$errors3, _actualError$errors3$;

        overrideData.title = (_actualError$errors$ = actualError === null || actualError === void 0 ? void 0 : (_actualError$errors = actualError.errors) === null || _actualError$errors === void 0 ? void 0 : (_actualError$errors$2 = _actualError$errors[0]) === null || _actualError$errors$2 === void 0 ? void 0 : _actualError$errors$2.title) !== null && _actualError$errors$ !== void 0 ? _actualError$errors$ : overrideData.title;
        overrideData.message = (_actualError$errors$3 = actualError === null || actualError === void 0 ? void 0 : (_actualError$errors2 = actualError.errors) === null || _actualError$errors2 === void 0 ? void 0 : (_actualError$errors2$ = _actualError$errors2[0]) === null || _actualError$errors2$ === void 0 ? void 0 : _actualError$errors2$.message) !== null && _actualError$errors$3 !== void 0 ? _actualError$errors$3 : overrideData.message;
        overrideData.errorCode = (_actualError$errors$4 = actualError === null || actualError === void 0 ? void 0 : (_actualError$errors3 = actualError.errors) === null || _actualError$errors3 === void 0 ? void 0 : (_actualError$errors3$ = _actualError$errors3[0]) === null || _actualError$errors3$ === void 0 ? void 0 : _actualError$errors3$.code) !== null && _actualError$errors$4 !== void 0 ? _actualError$errors$4 : overrideData.errorCode;
      } else if (actualError instanceof Error) {
        overrideData.message = actualError === null || actualError === void 0 ? void 0 : actualError.message;
      }

      return overrideData;
    }
  }]);

  return Common;
}();

export { Common as default };